import { addStyles } from 'ethcss'
import { colors, IStyles, mediaCSS } from 'theme'

export const styles: IStyles = {
    modalWrapper: {
        width: 1440,
        margin: '0 auto',
        padding: '0 30px',

        [mediaCSS.desktopML]: {
            width: 1240,

            [mediaCSS.desktopL]: {
                width: 768,
                padding: '0 10px',

                [mediaCSS.tab]: {
                    width: '100%',
                },
            },
        },
    },
    header: {
        position: 'relative',
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 50,

        [mediaCSS.desktopL]: {
            display: 'block',
        },
    },
    title: {
        position: 'absolute',
        top: 0,
        left: '50%',
        transform: 'translateX(-50%)',
        fontSize: 24,
        fontWeight: 700,

        [mediaCSS.desktopL]: {
            position: 'static',
            fontSize: 16,
            transform: 'none',
            textAlign: 'center',
            marginBottom: 20,
        },
    },
    headerButtons: {
        display: 'flex',

        [mediaCSS.desktopL]: {
            flexDirection: 'row-reverse',
            width: '100%',
            justifyContent: 'space-between',
        },
    },
    createKeyButton: {
        marginLeft: 10,

        [mediaCSS.desktopL]: {
            marginLeft: 0,
        },
    },
    apiKeysTableWrapper: {
        marginTop: 40,
        overflow: 'auto',

        [mediaCSS.desktopL]: {
            marginTop: 20,
        },

        table: {
            width: '100%',
            borderCollapse: 'collapse',
        },

        tr: {
            borderBottom: `1px solid ${colors.grey}`,

            '&:hover': {
                td: {
                    opacity: 1,
                },
            },
        },

        td: {
            padding: '0 20px',
            height: 72,
            verticalAlign: 'middle',

            [mediaCSS.desktopL]: {
                padding: 14,
                height: 'auto',
            },
        },
    },
    keyName: {
        [mediaCSS.desktopL]: {
            maxWidth: 120,
            wordWrap: 'break-word',
        },
    },
    headerRow: {
        fontWeight: '700',
    },
    delete: {
        opacity: 0,
        transition: 'opacity 0.3s',
    },
    createApiKey: {
        position: 'fixed',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        backgroundColor: 'rgba(0,0,0,0.7)',
    },
    createApiKeyInner: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        width: 420,
        padding: 30,
        borderRadius: 20,
        backgroundColor: colors.white,
    },
    caption: {
        fontSize: 22,
        marginBottom: 10,
    },
    text: {
        marginBottom: 6,
    },
    field: {
        marginTop: 20,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 30,
    },
    button: {
        margin: '0 5px',
    },
    checkboxLabel: {
        fontSize: 14,
    },
    checkboxWrapper: {
        paddingTop: 20,
    },
    fieldWithIcon: {
        position: 'relative',
    },
    copyIcon: {
        position: 'absolute',
        bottom: 10,
        right: 12,
        opacity: 0.7,
        transition: 'opacity 0.3',

        '&:hover': {
            opacity: 1,
        },
    },
    inputClassName: {
        paddingRight: '35px !important',
    },
}

addStyles(styles)
